import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import { theme } from "./theme";
import { installAuthInterceptor, clearSession } from "./utils/auth";

function AuthBoundary({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    installAuthInterceptor(() => {
      clearSession();
      navigate("/", { replace: true });
    });
  }, [navigate]);
  return children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthBoundary>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/cadastro" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
